export const comparablesInstructions =
  'Click the "Pull Comps" button to list comparables for this property.';

export const comparablesFilterDescription =
  'Comparables will, by default, use the values of your current property. The filters below allow you to customize the comps search further.';

export const pullCompsButtonText = 'Pull comparables';

export const refreshCompsButtonText = 'Refresh comparables';

export const calculateARVButtonText = 'Estimate ARV';

export const enterAddressWarning =
  'Please enter address and zip for the property to continue';

export const selectCompsForARVText = 'Select to Estimate ARV';

export const arvUpdatedMessage =
  'ARV has been updated. See the Cost Details tab -> Property Details -> Sell Price';

export const comparablesWarningMessage =
  'Sorry, there were no comparable homes found for this property. Please check the address and filter options and try again.';

export const statusIconMap = {
  'For Sale': 'home-outline',
  'Coming Soon': 'timer-outline',
  'Off Market': 'eye-off-outline',
  Sold: 'checkmark-done-circle-outline',
  Pending: 'hourglass-outline',
};

export const defaultMinYearBuilt = 1850;
